import React from "react";

import Button from "components/button";
import DiscoverEnerfloButtonWithOverlay from "components/discover-enerflo-button-with-overlay";
import Heading from "components/heading";

import RequestCallbackButton from "components/request-callback/button-with-overlay";

import HeroSection from "../../hero-section";

const title = "Access to Next-Level AI Reporting Starts Here";

const Access = () => (
  <>
    <HeroSection title={title} className="sm:py-16 lg:py-20">
      <div className="grow flex flex-col items-center">
        <HeroSection.Content className="w-full md:text-center">
          <HeroSection.Header className="mb-10">
            <Heading tag="h2" className="text-navy">
              {title}
            </Heading>
          </HeroSection.Header>
          <HeroSection.Description className="font-bold text-gray-700 text-lg mb-4">
            Experience the most advanced AI reporting suite in solar.
          </HeroSection.Description>
          <HeroSection.Description className="text-gray-700 max-w-3xl mx-auto">
            <DiscoverEnerfloButtonWithOverlay>
              {({ onOpen }) => (
                <Button onClick={onOpen} variant="link" className="underline">
                  Book a Discovery Call
                </Button>
              )}
            </DiscoverEnerfloButtonWithOverlay>{" "}
            or{" "}
            <RequestCallbackButton>
              {({ onOpen }) => (
                <Button onClick={onOpen} variant="link" className="underline">
                  Request a Callback
                </Button>
              )}
            </RequestCallbackButton>{" "}
            -- and we’ll show you how Enerflo makes access to better data insights your competitive edge.
          </HeroSection.Description>
        </HeroSection.Content>
      </div>
    </HeroSection>
    <div className="bg-gray-100">
      <HeroSection title={title}>
        <div className="grow flex flex-col items-center">
          <HeroSection.Content className="w-full md:text-center space-y-4">
            <HeroSection.Description className="font-bold text-gray-700">
              Already an Enerflo Partner?
            </HeroSection.Description>
            <HeroSection.Description className="max-w-4xl mx-auto text-gray-700">
              Great news—Enerflo’s new reporting suite is included with your Enerflo subscription! Contact your Partner
              Success Manager (PSM) to enable the new reporting suite on your account.
            </HeroSection.Description>
          </HeroSection.Content>
        </div>
      </HeroSection>
    </div>
  </>
);

export default Access;
